import { Controller } from '@hotwired/stimulus';
import * as Turbo from '@hotwired/turbo';

export default class extends Controller {
  static readonly values = {
    formId: String,
    disableFormButtons: Boolean,
  };

  declare formIdValue: string;
  declare disableFormButtonsValue: string;

  private isRedirecting: boolean = false;

  onSubmitEnd = () => {
    if (this.isRedirecting && this.disableFormButtonsValue) {
      this.disableFormButtons();
    }
  };

  onBeforeFetchResponse = async (event: CustomEvent) => {
    if (
      event.target &&
      (event.target as HTMLElement)?.id == this.formIdValue &&
      event.detail.fetchResponse.response.redirected
    ) {
      event.preventDefault();
      this.isRedirecting = true;
      await Turbo.visit(event.detail.fetchResponse.response.url);
    }
  };

  private disableFormButtons() {
    const buttons = this.element?.getElementsByTagName('button');
    if (buttons) {
      for (const button of buttons) {
        button.disabled = true;
      }
    }
  }
}
